var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetaHighlighted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 20,
    height: 9,
    fill: "#FF8736"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45 13.3H9.898L10.468 13.87V15.034L10.198 15.31L10.654 15.772V16.894L10.048 17.5H7.45V13.3ZM9.634 15.148L9.904 14.878V14.056L9.634 13.792H8.014V15.148H9.634ZM9.772 17.008L10.09 16.696V15.94L9.772 15.622H8.014V17.008H9.772ZM11.3758 13.3H14.1958V13.804H11.9518V15.142H14.0218V15.64H11.9518V16.996H14.1958V17.5H11.3758V13.3ZM15.8808 13.798H14.6148V13.3H17.7228V13.798H16.4568V17.5H15.8808V13.798ZM18.9319 13.3H19.5079L21.0199 17.5H20.4259L20.0539 16.432H18.3919L18.0199 17.5H17.4259L18.9319 13.3ZM19.9039 15.946L19.2259 13.984H19.2139L18.5479 15.946H19.9039Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaHighlighted);
export default __webpack_public_path__ + "static/media/beta_highlighted.0444ee381c9ce9c6be1158c7c23b42a2.svg";
export { ForwardRef as ReactComponent };